import {NgModule} from '@angular/core';
import {ActivityLogComponent} from './components/activity-log/activity-log.component';
import {CommonModule} from '@angular/common';


@NgModule({
  declarations: [
    ActivityLogComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [],
  exports: [
    ActivityLogComponent
  ]
})
export class ActivityLogModule {
}
